import {
  Wole,
  Shola,
  Lucia,
  Gabby,
  Aminat,
  Fadoon,
  Segun,
  Maero,
  Ogwu,
  Gloria,
  Favour,
  Angela,
} from "assets/images/meetTheTeam";

export const meetTheTeam = [
  {
    image: Wole,
    bgColor: "light",
    roleColor: "white",
    name: "Wole Olabanji",
    role: "Co-Founder & CEO",
    description:
      "Wole holds a Master’s degree in Architecture and an MBA, with over 21 years of experience in design consulting, construction finance, and development management. His career reflects a deep understanding of both the creative and financial dimensions of the built environment.",
  },
  {
    image: "",
    bgColor: "light",

    name: "Shola Adeniyi",
    role: "Co-Founder / Products",
    description:
      "With a background in Architecture and Software Development, Shola brings enterprise expertise in data and cloud infrastructure. As co-founder, Shola drives innovation, strategy, and collaboration to deliver impactful solutions. Outside of work, he enjoys cycling, camping, and hiking.",
  },
  {
    image: Lucia,
    bgColor: "dark",
    roleColor: "white",
    name: "Lucia Eke",
    role: "Software Developer",
    description:
      "Lucia is a Frontend Developer with a strong enthusiasm for creating engaging and visually appealing web applications. Beyond her work in technology, she is a passionate music lover and vocalist, blending creativity and innovation to bring ideas to life.",
  },
  {
    image: Gabby,
    bgColor: "light",
    roleColor: "blue",
    name: "Gabriel Jonah",
    role: "Lead, Software Team",
    description:
      "Gabriel is a full-stack and cloud engineer passionate about secure, scalable solutions. At Bankole, he leads with innovation and mentorship, creating impactful technologies that address real-world challenges while crafting digital experiences that unite functionality with design.",
  },
  {
    image: Aminat,
    bgColor: "dark",
    roleColor: "white",
    name: "Aminat Ameen",
    role: "Software Developer",
    description:
      "Aminat is a detail-oriented Software Engineer with expertise in React, TypeScript, and modern web technologies. She has experience building scalable web and mobile applications and integrating frontend solutions with backend services.",
  },
  {
    image: Fadoon,
    bgColor: "light",
    roleColor: "blue",
    name: "Fadoon Tarnongu ",
    role: "Software Developer",
    description:
      "Fadoon is a Backend Developer focused on building scalable, user-centered systems with clean, reliable architecture. Beyond coding, she enjoys exploring new ideas, relaxing with music or sitcoms, and sharpening problem-solving skills through solitaire and sudoku.",
  },
  {
    image: Segun,
    bgColor: "light",
    roleColor: "blue",
    name: "Segun Raji ",
    role: "Portfolio Manager",
    description:
      "Segun holds a Master’s degree in Construction Project Management and brings over 15 years of experience delivering large-scale projects across the Telecom and Real Estate sectors. His expertise spans project execution, stakeholder coordination, and ensuring quality outcomes.",
  },
  {
    image: Maero,
    bgColor: "dark",
    roleColor: "blue",
    name: "Maero Uwede",
    role: "UI/UX Designer",
    description:
      "Maero is a Product Designer with seven years’ experience shaping SaaS products across multiple industries. He focuses on UX research and scalable design systems, guided by the belief that complex workflows should always feel clear and effortless.",
  },

  {
    image: Ogwu,
    bgColor: "light",
    roleColor: "blue",
    name: "Ogwu Ogwu",
    role: "Project Manager /Quantity Surveyor",
    description:
      "Ogwu holds a First-Class Bachelor’s degree in Quantity Surveying and is a professional member of the NIQS. With nearly a decade of experience, he has specialized in managing project budgets and ensuring financial efficiency across diverse projects.  ",
  },
  {
    image: Gloria,
    bgColor: "light",
    roleColor: "blue",
    name: "Gloria Thomas ",
    role: "Quantity Surveyor",
    description:
      "Gloria holds a BSc in Quantity Surveying and has spent the past three years building expertise in cost estimation and project management. She has supported the successful delivery of multiple construction projects, ensuring precision and efficiency throughout the process.",
  },
  {
    image: Angela,
    bgColor: "light",
    roleColor: "blue",
    name: "Angela Idiaru",
    role: "Software Developer",
    description:
      "Angela is a Frontend Developer passionate about creating intuitive, responsive, and user-friendly web applications. She loves taking on new challenges, solving problems, and turning ideas into products that are both practical and enjoyable to use.",
  },
];
